var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberTypeLocationPartnerStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1731_30467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1.5C6.56981 1.5 6.63875 1.5176 6.7002 1.55176L6.70215 1.55273L11.7783 4.34961H11.7793C11.8453 4.38606 11.9005 4.44 11.9395 4.50586C11.9688 4.55559 11.9884 4.61076 11.9961 4.66797L12 4.72559V10.2764C11.9996 10.3532 11.9783 10.4284 11.9395 10.4941C11.9005 10.56 11.8453 10.6139 11.7793 10.6504H11.7783L6.70215 13.4473L6.7002 13.4482C6.63875 13.4824 6.56981 13.5 6.5 13.5C6.43019 13.5 6.36125 13.4824 6.2998 13.4482L6.29785 13.4473L1.22168 10.6504H1.2207C1.1547 10.6139 1.0995 10.56 1.06055 10.4941C1.03117 10.4444 1.01163 10.3892 1.00391 10.332L1 10.2744V4.72559C1.00017 4.6482 1.02148 4.572 1.06055 4.50586C1.0995 4.44 1.15469 4.38606 1.2207 4.34961H1.22168L6.29785 1.55273L6.2998 1.55176C6.36125 1.5176 6.43019 1.5 6.5 1.5Z",
    fill: "#1EA77A",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1731_30467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberTypeLocationPartnerStatus);
export default __webpack_public_path__ + "static/media/MemberTypeLocationPartnerStatus.d62e32239c591e7e718b9f7a92b4227c.svg";
export { ForwardRef as ReactComponent };